import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from 'layout/header';
import Footer from 'layout/footer';
import PageHeader from 'component/PageHeader';
import imgTop02 from '../../assets/images/img_top02.png';
import imgStepPc from '../../assets/images/img_step.png';
import imgStepTb from '../../assets/images/img_step_t.png';
import imgStepMo from '../../assets/images/img_step_m.png';

const Career = () => {
    const [pageTitle] = useState("채용안내"); // 기본 타이틀

    const breadcrumb = [
        { label: "홈", path: "/main" },
        { label: "채용안내" },
    ];

    const ideals = [
        {logoName : 'takein', txt : '유연한 사고와 학습력', list01 : '새로운 지식과 정보를 빠르게 받아들이고 배우는 능력', list02 : '조직의 변화 요구에 유연하게 적응하며 꾸준히 성장하는 태도'},
        {logoName : 'fillin', txt : '팀워크와 협력', list01 : '팀 내에서 필요한 역활을 채우고 동료를 도와주는 협력적인 자세', list02 : '동료와 회사의 필요를 충족시키기 위해 헌신하는 태도'},
        {logoName : 'kickin', txt : '능동적인 참여와 실행력', list01 : '팀의 목표를 달성하기 위해 나서서 행동하는 능동적인 인재', list02 : '문제 해결을 위해 적극적으로 기여하고 실행력을 발휘하는 모습'},
        {logoName : 'goalin', txt : '목표 지향적 태도', list01 : '명확한 목표를 설정하고 이루기 위해 꾸준히 노력하는 모습', list02 : '주어진 목표를 성취 하기 위해 집중력과 끈기를 발휘하는 자세'},
    ];

    const benefits = [
        {iconName : 'meal', tit : '식사 지원', txt : '든든하게 업무에 몰입할 수 있도록 점심을 제공해 드려요.'},
        {iconName : 'prize', tit : '우수사원 포상', txt : '매 년 우수한 사원 및 부서에 대해 포상을 실시하고 있어요.'},
        {iconName : 'amenities', tit : '사내편의시설', txt : '임직원의 편의를 위해 안마의자부터 게임, 커피 및 간식까지 다양하게 제공하고 있어요.'},
        {iconName : 'growth ', tit : '성장 지원', txt : '자기개발을 위한 학위취득, 자격증비, 도서비, 세미나등 개인의 성장을 적극 지원해 드려요.'},
        {iconName : 'activity', tit : '사내 동호회 활동지원', txt : '건강한 여가생활을 위해 다양한 동호회 증설 및 활동을 적극 지원해요.'},
        {iconName : 'gift ', tit : '기념 선물 지원', txt : '입사시 웰컴 키트 제공 뿐만아니라 생일, 입사일에 소정의 선물 지급해 드려요.'},
        {iconName : 'award ', tit : '장기근속 포상', txt : '일정기간 동안 근속한 임직원에 대해 상여 및 휴가를 제공해 드려요.'},
        {iconName : 'point ', tit : '복지포인트 지원', txt : '연간 복지포인트를 지급하여 다양한 복지혜택을 누릴 수 있도록 지원해요.'},
        {iconName : 'support ', tit : '경조사 지원', txt : '임직원의 경조사에 대해 기쁨과 슬픔을 함께 나눌 수 있도록 경조금과 경조휴가, 화환 등 제공'},
    ];

    //채용절차
    const [currentImage, setCurrentImage] = useState(imgStepPc);

    const updateImage = () => {
        const width = window.innerWidth;
        if (width <= 768) {
            setCurrentImage(imgStepMo);
        } else if (width <= 1023) {
            setCurrentImage(imgStepTb);
        } else {
            setCurrentImage(imgStepPc);
        }
    };
    useEffect(() => {
        updateImage();
        window.addEventListener("resize", updateImage);
        return () => {
          window.removeEventListener("resize", updateImage);
        };
    }, []);
        
    // const steps = [
    //     {itemName : 'first', tit : '서류전형', txt : '이력서 및 자기소개서를 통해 확인되는 역량 검토', valid : '※ 경력사원의 경우 경력기술서 제출'},
    //     {itemName : 'second', tit : '1차 면접', txt : '지원자의 인적사항 및 역량 파악을 위해 간단한 전화면접 실시'},
    //     {itemName : 'third', tit : '2차 면접', txt : '채용 포지션과 관련된 지식, 경험, 역량을 확인하며 필요에 따라 테스트 요청 및 진행'},
    //     {itemName : 'four ', tit : '최종 합격', txt : '최종 합격한 지원자와 입사일 및 처우를 협의한 뒤 입사에 필요한 상세 안내를 진행'},
    // ];

    // AOS 초기화 및 리프레시
    useEffect(() => {
        AOS.init();
    }, []);

  return (
    <div id="wrap">
        <Header />
        <section className="section">
            <PageHeader
                title={pageTitle}
                backgroundImage={imgTop02}
                breadcrumb={breadcrumb.map(item => {
                    return item;
                })}
            />

            <div className="content career">
                <div className="container">
                    <p className="content-title"  data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="500">인재상</p>
                    <p className="sub-txt"  data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="500">사람과 사람이 모여 INIS가 나아갈 방향을 함께 고민하고 이끌어 갈 수 있는 인재를 환영합니다.</p>
                    <div className="card-box"  data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="500">
                        {ideals.map((card) => (
                            <div className="card">
                                <span className={`logo ${card.logoName}`}><i className="blind">{card.logoName}</i></span>
                                <span className="txt">{card.txt}</span>

                                <div className="hover-box">
                                    <ul className="list-dot">
                                        <li>{card.list01}</li>
                                        <li>{card.list02}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>

                    <p className="content-title"  data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="600">복리후생</p>
                    <p className="sub-txt" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="600">임직원의 성장과 행복을 추구하며, 지속적인 개인 역량 강화를 지원합니다.</p>
                    <div className="benefit-box" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="600">
                        <ul>
                            {benefits.map((item) => (
                                <li className="item">
                                    <span className={`icon ${item.iconName}`}><i className="blind">{item.iconName}</i></span>
                                    <span className="tit">{item.tit}</span>
                                    <span className="txt">{item.txt}</span>
                                </li>
                            ))}
                            
                        </ul>
                    </div>

                    <p className="content-title" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="700">채용절차</p>
                    <p className="sub-txt" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="700">도전적인 자세로 혁신을 주도할 인재, 아이엔아이소프트와 함께 성장해나갑니다.</p>
                    <div className="step-box" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="700">
                        <img src={currentImage} alt="채용절차" />
                        {/* <ul>
                            {steps.map((item) => (
                                <li className={`item ${item.itemName}`}>
                                    <span className="tit">{item.tit}</span>
                                    <span className="txt">{item.txt}</span>
                                    <p className="validation-txt">{item.valid}</p>
                                </li>
                            ))}
                        </ul> */}
                    </div>
                    <div className="btn-group">
                        {/* 외부링크 연결은 a태그, 내부는 Link */}
                        <a 
                            href="https://www.jobkorea.co.kr/Recruit/Co_Read/Recruit/C/18630526" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="btn apply"
                        >
                            지원하기
                        </a>
                    </div>        
                </div>
            </div>
          
          
        </section>
        <Footer />
    </div>
  );
};

export default Career;
